module.exports = {
  "useSentry": true
};